import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import CircularProgress from '@material-ui/core/CircularProgress'

import Login from './Login'
import { actions as authActions } from '../actions'
import { NAME as AUTH_NAME } from '../reducer'

const centered = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

// Decides between the login screen and the app. The session cookie is httpOnly,
// so the answer can only come from the API.
export function SessionGate({ status, fetchSession, children }) {
  React.useEffect(() => {
    fetchSession()
  }, [fetchSession])

  if (status === 'checking') {
    return (
      <div style={centered}>
        <CircularProgress />
      </div>
    )
  }

  if (status !== 'authenticated') {
    return <Login />
  }

  return children
}

const mapStateToProps = (state) => ({ status: state[AUTH_NAME].status })

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchSession: authActions.fetchSession }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SessionGate)
